import type { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import type { Sites } from '@ps/platform-message-framework/common/Sites';
import type { ActiveGameType } from '@ps/web-poker-types';

export interface ActiveTableState {
  activeTablesCount: number;
}

export interface Message {
  type: MessageType;
  data?: ActiveTableConfig | FocusTableConfig;
}

export enum MessageType {
  FOCUS_GAME = 'focus_game',
  HANDSHAKE = 'handshake',
  OPEN_GAME = 'open_game'
}

export enum OpenTableAction {
  ALREADY_ACTIVE = 'already_active',
  FOCUS = 'focus',
  OPEN = 'open'
}

export interface OpenWindowState {
  win: Window | null;
  action: OpenTableAction;
}

export interface ActiveTableConfig {
  brand: BrandTypes;
  site: Sites;
  origin: string;
  country: string | undefined;
  xiid: string;
  timezone: string;
  newtab: boolean;
  gametype: string;
  endpoint?: string;
  hasvideosupport?: boolean;
  flags?: number;
  scriptId?: string | number;
}

export interface FocusTableConfig {
  id: number;
  type: ActiveGameType;
}
